import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import ReactToolTip from 'react-tooltip';

import { readClient } from '../../client';
import { AppWrap, MotionWrap } from '../../wrapper';
import { getSanityImageProps } from '../../utils/sanityImage';

import './Skills.scss';

export const Skills = () => {
  const [skills, setSkills] = useState([]);
  const [experiences, setExperiences] = useState([]);

  useEffect(() => {
    const query = '*[_type == "experiences"] | order(_updatedAt desc)';
    const skillsQuery = '*[_type == "skills"]';

    readClient.fetch(skillsQuery).then(setSkills);
    readClient.fetch(query).then(setExperiences);
  }, []);

  return (
    <>
      <h2 className="head-text">Skills, Experience &amp; Education</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name}
            >
              <div className="app__flex" style={{ backgroundColor: skill.bgColor }}>
                <img
                  {...getSanityImageProps(skill.icon, {
                    candidates: [
                      { width: 45, height: 45 },
                      { width: 90, height: 90 },
                      { width: 150, height: 150 },
                    ],
                    sizes: '(min-width: 2000px) 75px, (max-width: 450px) 35px, 45px',
                    fit: 'max',
                  })}
                  loading="lazy"
                  decoding="async"
                  alt={`${skill.name} logo`}
                />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div className="app__skills-details">
          <div className="app__skills-exp">
            {experiences.map((experience) => (
              <motion.div
                className="app__skills-exp-item"
                key={experience.year}
              >
                <div className="app__skills-exp-year">
                  <p className="bold-text">{experience.year}</p>
                </div>
                <motion.div className="app__skills-exp-works">
                  {experience.works.map((work) => (
                    <React.Fragment key={`${experience.year}-${work.name}`}>
                      <motion.div
                        whileInView={{ opacity: [0, 1] }}
                        transition={{ duration: 0.5 }}
                        className="app__skills-exp-work app__flex"
                        data-for={`${experience.year}-${work.name}`}
                        data-tip
                      >
                        <h4 className="bold-text">{work.name}</h4>
                        <p className="p-text">{work.company}</p>
                      </motion.div>

                      <ReactToolTip
                        id={`${experience.year}-${work.name}`}
                        effect="solid"
                        arrowColor="#fff"
                        className="skills-tooltip"
                      >
                        {work.desc}
                      </ReactToolTip>
                    </React.Fragment>
                  ))}
                </motion.div>
              </motion.div>
            ))}
          </div>

          <motion.article
            className="app__skills-education"
            whileInView={{ opacity: [0, 1], y: [20, 0] }}
            transition={{ duration: 0.5 }}
          >
            <p className="app__skills-education-dates bold-text">2010–2015</p>
            <div>
              <h3 className="bold-text">Bachelor&apos;s degree in Mechanical Engineering</h3>
              <p className="p-text app__skills-education-school">Covenant University</p>
              <p className="p-text">
                My engineering background strengthened the analytical problem-solving
                and systems thinking I bring to full-stack development and technical tutoring.
              </p>
            </div>
          </motion.article>
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__whitebg',
);
